import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Flame, Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (sid) {
        try {
          const r = await api.post("/auth/session", { session_id: sid });
          setUser(r.data);
        } catch (e) {
          if (e?.response?.status === 403) {
            window.history.replaceState(null, "", "/?denied=1");
            nav("/?denied=1", { replace: true });
            return;
          }
          console.error("Session exchange failed:", e);
        }
      }
      window.history.replaceState(null, "", "/");
      nav("/", { replace: true });
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <div className="w-11 h-11 rounded-md bg-brand flex items-center justify-center">
        <Flame className="w-6 h-6 text-white" strokeWidth={2} />
      </div>
      <div className="flex items-center gap-2 text-white/60 font-mono text-sm">
        <Loader2 className="w-4 h-4 animate-spin" /> Signing you in…
      </div>
    </div>
  );
}
